var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[(_vm.data.length > 0)?_c('div',{staticClass:"bottom_data"},[_c('h1',[_vm._v(_vm._s(_vm.$t('战略合作单位')))]),_vm._v(" "),_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{staticClass:"companys"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"company"},[_c('img',{attrs:{"src":item.logo}})])}),0)])],1):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-551d906e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/product/components/Bottom.vue
// module id = null
// module chunks = 